import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../services/mainApi.service";
import { ITasySchedMenu } from "../../../../../models/tasy-sched-menu";

const TASY_SCHED_MENU_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v1/TasySchedMenu/";

const tasySchedMenuService = new MainApi<ITasySchedMenu>(TASY_SCHED_MENU_ROUTE);

const translationPath = "page.settings.schedule.tasySchedMenu.";

const TasySchedMenuPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { eI } = useParams();

  const columns: GridColDef<ITasySchedMenu>[] = useMemo(
    () => [
      {
        field: "name",
        headerName: t(translationPath + "name") || "Name",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "displayOrder",
        headerName: t(translationPath + "display_order") || "Display order",
        minWidth: 140,
      },
      {
        field: "customMessage",
        headerName: t(translationPath + "custom_message") || "Custom message",
        flex: 1,
        minWidth: 220,
        renderCell: (params) => {
          return params.value?.replace(/<[^>]*>/g, " ") ?? "-";
        },
      },
      {
        field: "ticketAutomationReceivedRule",
        headerName:
          t(translationPath + "ticket_automation_received_rule") ||
          "Automation received rule",
        flex: 1,
        minWidth: 260,
        renderCell: (params) => {
          return params.value?.name ?? "-";
        },
      },
    ],
    [t],
  );

  const handleRowClick = (params: GridRowParams<ITasySchedMenu>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<ITasySchedMenu>
      showDefaultMacroFilters={false}
      service={tasySchedMenuService}
      columns={columns}
      title={t(translationPath + "menu_scheduling_portal_app")}
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInput={false}
      backButton
      backButtonUrl={`/e/${eI}/dashboard/settings`}
      searchInputPlaceHolder={
        t(translationPath + "search") ||
        "Search for a portal and app scheduling menu"
      }
      addButtonLabel={
        t(translationPath + "add_menu_scheduling_portal_app") ||
        "Add portal and app scheduling menu"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default TasySchedMenuPage;
